import { render, staticRenderFns } from "./InformationBar.vue?vue&type=template&id=9550587a&scoped=true&"
import script from "./InformationBar.vue?vue&type=script&lang=js&"
export * from "./InformationBar.vue?vue&type=script&lang=js&"
import style0 from "./InformationBar.vue?vue&type=style&index=0&id=9550587a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9550587a",
  null
  
)

export default component.exports